import { booleanAttribute, Component, EventEmitter, Input, Optional, Output, TrackByFunction } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { SecurityRegistryRecord } from '@models/shares/security-registry-record';
import {
  SecurityHolderIconLabelComponent
} from '@shared/components/shares/security-holder-icon-label/security-holder-icon-label.component';
import { LinkComponent } from '@shared/components/commons/link/link.component';
import { ValidationErrorComponent } from '@shared/controls/validation-error/validation-error.component';
import { customSignErrors } from "../../models/shares/company-security-cancellation.model";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: 'app-select-shareholder',
  standalone: true,
  imports: [
    LinkComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    ValidationErrorComponent,
    SecurityHolderIconLabelComponent,
    NgTemplateOutlet
  ],
  templateUrl: './select-shareholder.component.html',
  styleUrls: ['../../../shared/controls/select/select.component.scss', 'select-shareholder.component.scss']
})
export class SelectShareholderComponent implements ControlValueAccessor {
  @Input() width = '100%';
  @Input() placeholder = ''
  @Input() label = ''
  @Input() link = ''
  @Input() text = ''
  @Input() helperText = '';
  @Input() noOptionsText = 'There are no available options.';
  @Input({ required: true }) groupedSecurityRegistryRecords: SecurityRegistryRecord[][] = [];
  @Input({ transform: booleanAttribute }) disabled = false;
  @Input({ transform: booleanAttribute }) isDisabled = false;

  @Output() select = new EventEmitter<SecurityRegistryRecord[]>();

  readonly customSignErrors = customSignErrors;

  #value: SecurityRegistryRecord[] | null = null;
  dropdownOpen = false;

  constructor(@Optional() protected ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  get value(): SecurityRegistryRecord[] | null {
    return this.#value;
  }

  set value(value: SecurityRegistryRecord[] | null) {
    this.#value = value;
    this.onChange(this.#value);
  }

  get displayValidationError(): boolean {
    return !!(this.ngControl && this.ngControl.touched && this.ngControl.errors);
  }

  selectOption(record: SecurityRegistryRecord[]): void {
    this.value = record;
    this.select.emit(record);
  }

  onChange: any = (): void => { };
  onTouched: any = (): void => { };

  writeValue(value: SecurityRegistryRecord[]): void {
    this.value = value;
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getDropdownState(dropdownState: boolean): void {
    this.dropdownOpen = dropdownState;
  }

  trackGroupedSecurityRegistryRecordsFn: TrackByFunction<SecurityRegistryRecord[]> = (index: number, records: SecurityRegistryRecord[]): string => {
    return records.flatMap((record) => record.holdings.flatMap((holding) => holding.hash))
      .join('');
  };
}
